import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { SpinnerIcon } from "@vfit/ui/icons";
import { SpinnerContainer } from "./loadingSpinner.style";
var LoadingSpinner = function(param) {
    var isChild = param.isChild;
    return /*#__PURE__*/ _jsx(SpinnerContainer, {
        isChild: isChild,
        children: /*#__PURE__*/ _jsx(SpinnerIcon, {})
    });
};
export default LoadingSpinner;
